import { getISODate } from "../getISODate";
const isToday = (date, config) => {
    const today = getISODate(new Date(Date.now()).toISOString(), config.currentTimeZone);
    return today && date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
};
const isTomorrow = (date, config) => {
    const tomorrow = getISODate(new Date(Date.now()).toISOString(), config.currentTimeZone);
    tomorrow && tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow && date.getDate() === tomorrow.getDate() && date.getMonth() === tomorrow.getMonth() && date.getFullYear() === tomorrow.getFullYear();
};
const getEventDate = (date, config) => {
    let resultDate = date.formatDate(config.dateFormat);
    if (config.useMonthName) {
        const monthNameShort = config.dict[`month-${date.getMonth()}-short`];
        const day = date.getDate().toString();
        const isMonthFirst = config.dateFormat.indexOf("MM") === 0;
        resultDate = isMonthFirst ? `${monthNameShort} ${day}` : `${day} ${monthNameShort}`;
        if (isToday(date, config)) {
            resultDate = config.dict.Today;
        }
        if (isTomorrow(date, config)) {
            resultDate = config.dict.Tomorrow;
        }
    }
    return resultDate;
};
export const mapStartDateTime = (event, config) => {
    const date = config.hasSettlementDate && event.metadata.settlementDate ?
        event.metadata.settlementDate : event.startEventDate;
    const eventDate = getISODate(date, config.currentTimeZone);
    event.eventDate = eventDate ? getEventDate(eventDate, config) : "--";
    event.eventTime = eventDate ? eventDate.formatDate(config.timeFormat) : "--";
    return event;
};
//# sourceMappingURL=mapStartDateTime.js.map